import { useEffect, useState } from "react";
import { api } from "./api";

// In-memory single-fetch cache for /api/config/public so multiple mount
// points don't hit the endpoint N times.  Values are refreshed on full
// page load only (config rarely changes at runtime).
let _cached = null;
let _inflight = null;

async function fetchConfig() {
  if (_cached) return _cached;
  if (_inflight) return _inflight;
  _inflight = api.get("/config/public").then(
    (r) => { _cached = r.data; _inflight = null; return _cached; },
    (err) => { _inflight = null; throw err; },
  );
  return _inflight;
}

/**
 * useConfig() — returns the /config/public payload (commerce_mode,
 * marketing tag ids, stripe publishable key) or {} while loading.
 * Cached across the SPA for the browser session.
 */
export function useConfig() {
  const [config, setConfig] = useState(_cached || {});
  useEffect(() => {
    if (_cached) { setConfig(_cached); return; }
    let cancelled = false;
    fetchConfig().then((c) => { if (!cancelled) setConfig(c); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return config;
}
